module.exports = __webpack_public_path__ + "static/media/info_popup.024e33d9.png";